import { Icon } from "@iconify/react";
import React from "react";

const NotFound = ({
  icon = "icon-park-outline:caution",
  message = "Oops! We’re having a little trouble loading those details. Give it a quick refresh or try again in a moment",
}) => {
  return (
    <div style={{ textAlign: "center", padding: '50px 0' }}>
      <Icon
        icon={icon}
        color="#387ed8"
        style={{ marginRight: 10, marginBottom: 10 }}
        fontSize={130}
      />
      <p className="text-center">{message}</p>
    </div>
  );
};

export default NotFound;
